/*!

=========================================================
* Vision UI Free React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vision-ui-free-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)
* Licensed under MIT (https://github.com/creativetimofficial/vision-ui-free-react/blob/master LICENSE.md)

* Design and Coded by Simmmple & Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// Vision UI Dashboard React components
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";

// Social Icons
import { FaTelegramPlane, FaYoutube, FaTwitter, FaBtc, FaTiktok } from "react-icons/fa";

function Footer() {
  return (
    <VuiBox
      display="flex"
      flexDirection={{ xs: "column", lg: "row" }}
      justifyContent="space-between"
      direction="row"
      component="footer"
      py={2}
      pb={0}
    >
      <VuiBox item xs={12} sx={{ textAlign: "center" }}>
        <VuiTypography
          variant="button"
          sx={{ textAlign: "center", fontWeight: "400 !important" }}
          color="white"
        >
          @ 2021, Made with <FaBtc color="gold" />
          &❤️&nbsp;&nbsp;&nbsp; by{" "}
          <VuiTypography
            component="a"
            variant="button"
            href="https://twitter.com/cr1pt0_d3v"
            target="_blank"
            sx={{ textAlign: "center", fontWeight: "600 !important" }}
            color="white"
            mr="6px"
            ml="6px"
          >
            cr1pt0_d3v🎭
          </VuiTypography>
          {"  "} for {"  "}
          <VuiTypography
            ml="5px"
            mr="2px"
            component="a"
            variant="button"
            href="https://t.me/+EZn2m0hCwaU1NDI0"
            sx={{ textAlign: "center", fontWeight: "500 !important" }}
            color="white"
          >
            Mr. Crypto Community
          </VuiTypography>
        </VuiTypography>
      </VuiBox>
      <VuiBox display="flex">
        <VuiBox mr="20px">
          <a href="https://t.me/mrcrypto5" target="_blank">
            <FaTelegramPlane color="white" />
          </a>
        </VuiBox>
        <VuiBox mr="20px">
          <a href="https://twitter.com/Mr_Crypto5" target="_blank">
            <FaTwitter color="white" />
          </a>
        </VuiBox>
        <VuiBox mr="20px">
          <a href="https://www.youtube.com/c/mrcrypto5" target="_blank">
            <FaYoutube color="white" />
          </a>
        </VuiBox>
        <VuiBox mr="20px">
          <a href="https://www.tiktok.com/@mrcrypto5" target="_blank">
            <FaTiktok color="white" />
          </a>
        </VuiBox>
      </VuiBox>
    </VuiBox>
  );
}

export default Footer;
